import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";

const { displayName } = config;

export default function SurveyEdit(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Survey Edit`;
  }, []);

  return (
    <Layout>
      {/* <SurveyEditContent /> */}
      SurveyEditContent
    </Layout>
  );
}
